import request from '@/services/interceptor.js'



// --------------------
// Consegne
// --------------------
export const get_consegne = (par) => {
    return request({
        url: '/consegne/' + par,
        method: 'get',
    })
};

export const scarica_consegna = (data) => {
    return request({
        url: '/consegne/multi',
        method: 'post',
        data: data,
    })
};

export const invia_coordinate = (par) => {
    return request({
        url: '/consegne/coordinate',
        method: 'post',
        data: par,
    })
};




// --------------------
// Magazzino
// --------------------
export const get_evasioneOrdine = (par) => {
    return request({
        url: '/magazzino/evasione/' + par,
        method: 'get',
    })
};

export const evadiRigoOrdine = (par) => {
    return request({
        url: '/magazzino/evasione',
        method: 'post',
        data: par,
    })
};

export const eliminaRigoEvasione = (par) => {
    return request({
        url: '/magazzino/evasione',
        method: 'delete',
        data: par,
    })
};

export const getUtenti = () => {
    return request({
        url: '/magazzino/utenti',
        method: 'get',
    })
};

export const get_ricevimento = (par) => {
    return request({
        url: '/magazzino/ricevimento/' + par,
        method: 'get',
    })
};

export const get_datiArticoli = (par) => {
    return request({
        url: '/magazzino/articolo/' + par,
        method: 'get',
    })
};

export const scortaArticolo = (par) => {
    return request({
        url: '/magazzino/scorte',
        method: 'post',
        data: par,
    })
};


export const riceviRigoOrdine = (par) => {
    return request({
        url: '/magazzino/ricevimento',
        method: 'post',
        data: par,
    })
};

export const riceviBolla = (par) => {
    return request({
        url: '/magazzino/ricevimento/bolla',
        method: 'post',
        data: par,
    })
};

export const eliminaRigoRicevimento = (par) => {
    return request({
        url: '/magazzino/ricevimento',
        method: 'delete',
        data: par,
    })
};

export const get_datiArticoliOrdiniFor = (par) => {
    return request({
        url: '/magazzino/ordinifornitori/' + par,
        method: 'get',
    })
};


export const preOrdine = (par) => {
    return request({
        url: '/magazzino/ordinifornitori/preordine',
        method: 'post',
        data: par
    })
};


export const get_pesoBilancia = (par) => {
    return request({
        url: '/magazzino/bilancia/' + par,
        method: 'get',
    })
};

export const set_pesoBilancia = (par) => {
    return request({
        url: '/magazzino/bilancia',
        method: 'post',
        data: par
    })
};



export const set_ubicazioni = (par) => {
    return request({
        url: '/magazzino/ubicazioni',
        method: 'post',
        data: par
    })
};

export const del_ubicazioni = (par) => {
    return request({
        url: '/magazzino/ubicazioni/' + par,
        method: 'delete',
    })
};

export const get_ubicazioniEsistenze = (par) => {
    return request({
        url: '/magazzino/ubicazioni/esistenze/' + par,
        method: 'get',
    })
};


export const get_maniglie = (par) => {
    return request({
        url: '/magazzino/maniglie/' + par,
        method: 'get',
    })
};

export const prelievo_maniglie = (data) => {
    return request({
        url: '/magazzino/maniglie',
        method: 'post',
        data: data
    })
};

export const richiama_cassetto = (data) => {
    return request({
        url: "/magazzino/preleva",
        method: 'post',
        data: data,
    })
}